export function isTablet() {
    const userAgent = typeof window.navigator === "undefined" ? "" : navigator.userAgent;
    return /ipad|tablet|android 3.0|xoom|sch-i800|playbook|tablet.*firefox|kindle|silk|gt-p1000|nexus 10|SHW-M380K|SM-T110|SM-T111|SM-T113|SM-T116|SM-T21[05]|LG-V700|Asus.*Transformer/i.test(userAgent)
}
